import { render, staticRenderFns } from "./VideoPublisherView.vue?vue&type=template&id=216d3b24&"
import script from "./VideoPublisherView.vue?vue&type=script&lang=js&"
export * from "./VideoPublisherView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports